import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const CommentListContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const HeaderItems = styled(Box)`
  display: flex;
  justify-content: space-between;
`

export const Header = styled(Typography)`
  ${typography.up1.regularSerif}
  align-items: center;
  display: flex;
`

export const Cards = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`

export const PaginationContainer = styled(Box)`
  display: flex;
  justify-content: center;
  padding-bottom: 16px;
`
